export function isSimpleStream(stream) {
    return stream.hasOwnProperty('items');
}
export function isLoadableStream(stream) {
    return !stream.hasOwnProperty('items');
}

//# sourceMappingURL=types.js.map